import { BudgetGoalSchema } from './schemas'

export const GOAL_MEASURE_UNIT: Record<BudgetGoalSchema['measure'], string> = {
  currency: '€',
  volume: 'm³'
} as const
